import { useCallback, useEffect, useState } from 'react'

import { cloneDeepWith } from '@src/utils/functions/utils'

import PubSub from './PubSub'

const useAppSelector = <T>(
  stateManager: PubSub,
  getter: (...args: any[]) => T,
  args: any[] = [],
  stateComparator?: (nextState: T, currentState: T) => boolean,
) => {
  const _args = args || ([] as any[])
  const _getter = useCallback(() => getter(..._args), [..._args, getter])

  const [state, setState] = useState<T>(_getter.call(stateManager))
  useEffect(() => {
    return stateManager.subscribe(() => {
      const newState = _getter.call(stateManager)
      setState(previousState => {
        if (stateComparator) {
          const isSame = stateComparator(newState, previousState)
          if (!isSame) return cloneDeepWith(newState)
          return previousState
        } else {
          return cloneDeepWith(newState)
        }
      })
    })
  }, [stateManager, _getter, stateComparator])
  return state
}

export { useAppSelector }
